<container-element [ngSwitch]="this.operation">
  <!-- Add -->
  <div *ngSwitchCase="1">
    <div>
      <div class="d-flex flex-row types__buisness justify-content-between">
        <div>{{title | translate}} *</div>
        <div *ngIf="item.invalid && (item.dirty || item.touched)" class="alert alert-danger">
          <div class="d-flex flex-row alert-danger-content">
            <div class="alert-danger-info" matTooltipClass="tooltip-danger"
              matTooltip="{{ 'INFO.CHOOSE_MORE_PATTERN' | translate }}">
              <div>?</div>
            </div>
          </div>
        </div>
      </div>
      <p-multiSelect [filter]="false" [showToggleAll]="true" filterPlaceHolder="{{'SEARCH' | translate}}..." [options]="list" (onChange)="shareCheckedlist()" [(ngModel)]="checkedList" [required]="true" #item="ngModel"
        defaultLabel="{{ 'INFO.CHOOSE_MORE' | translate }}" optionLabel="name" optionValue="id" [maxSelectedLabels]="2"
        selectedItemsLabel="{0} {{ 'INFO.ITEMS_SELECTED' | translate }}">
        <ng-template pTemplate="header">
          <div class="checkbox-all-text">{{ "SELECT_ALL" | translate }}</div>
        </ng-template>
      </p-multiSelect>
    </div>
  </div>
  <!-- Edit -->
  <div *ngSwitchCase="2">
    <div class="d-flex flex-row types__buisness justify-content-between">
      <div>{{title | translate}} *</div>
      <div *ngIf="item.invalid && (item.dirty || item.touched)" class="alert alert-danger">
        <div class="d-flex flex-row alert-danger-content">
          <div class="alert-danger-info" matTooltipClass="tooltip-danger" matTooltip="{{ 'INFO.CHOOSE_MORE_PATTERN' | translate }}">
            <div>?</div>
          </div>
        </div>
      </div>
    </div>
    <p-multiSelect [filter]="false" [showToggleAll]="true" filterPlaceHolder="{{'SEARCH' | translate}}..." [options]="list" (onChange)="shareCheckedlist()" [(ngModel)]="checkedList" [required]="true" #item="ngModel"
      defaultLabel="{{ 'INFO.CHOOSE_MORE' | translate }}" optionLabel="name" optionValue="id" [maxSelectedLabels]="2"
      selectedItemsLabel="{0} {{ 'INFO.ITEMS_SELECTED' | translate }}">
      <ng-template pTemplate="header">
        <div class="checkbox-all-text">{{ "SELECT_ALL" | translate }}</div>
      </ng-template>
    </p-multiSelect>
  </div>
  <!-- Read -->
  <div *ngSwitchCase="4">
    <div class="d-flex flex-row types__buisness justify-content-between">
      <div>{{title | translate}}</div>
      <div *ngIf="item.invalid && (item.dirty || item.touched)" class="alert alert-danger">
        <div class="d-flex flex-row alert-danger-content">
          <div class="alert-danger-info" matTooltipClass="tooltip-danger" matTooltip="{{ 'INFO.CHOOSE_MORE_PATTERN' | translate }}">
            <div>?</div>
          </div>
        </div>
      </div>
    </div>
    <p-multiSelect [filter]="false" [showToggleAll]="true" filterPlaceHolder="{{'SEARCH' | translate}}..." [options]="list" [(ngModel)]="checkedList" [required]="true" #item="ngModel" defaultLabel="{{ 'INFO.CHOOSE_MORE' | translate }}" optionLabel="name"
      optionValue="id" optionDisabled="name" [maxSelectedLabels]="2" selectedItemsLabel="{0} {{ 'INFO.ITEMS_SELECTED' | translate }}">
      <ng-template pTemplate="header">
        <div class="checkbox-all-text">{{ "SELECT_ALL" | translate }}</div>
      </ng-template>
    </p-multiSelect>
  </div>

  <!--default case when there are no matches -->
  <div *ngSwitchDefault>...</div>
</container-element>